import { Component, Input, OnInit, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MpjobService } from 'src/app/services/jobs/mpjob.service';
import { Location, LocationStrategy } from '@angular/common';


@Component({
  selector: 'app-mpjob',
  templateUrl: './mpjob.component.html',
  styleUrls: ['./mpjob.component.scss']
})
export class MpjobComponent implements OnInit {
  job: any;
  jobId: any;
  loading;
  user
  clientData
  addLearner
  trackerDetails
  @Input('jobFromClient') jobFromClient;
  selectedTab: any;
  singleJobDetails: any;
  hideTitle = false;

  constructor(private router: Router, public _mpjobService: MpjobService, public activatedRoute: ActivatedRoute,
    private location: Location, private locationStrategy: LocationStrategy, private cdr: ChangeDetectorRef) {
    // if (this.router.getCurrentNavigation() && this.router.getCurrentNavigation().extras && this.router.getCurrentNavigation().extras.state) {
    //   this.job = this.router.getCurrentNavigation().extras.state.job
    // }
  }

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe(qparams => {
      if (!qparams['currentTab']) {
        console.log("in IF qparams['currentTab']", qparams['currentTab'])
        // this.router.navigate(['.'], { relativeTo: this.activatedRoute, queryParams: { currentTab: 0 } });
      }
      else this.selectedTab = qparams['currentTab']
    })
    this.user = JSON.parse(localStorage.getItem('userRoles'))
    console.log("NG ON INIT", this.job)
    // ON REFRESH
    if (!this.job) {
      this.activatedRoute.params.subscribe(param => {
        console.log("params", param)
        if (param.jobid) {
          this.jobId = param.jobid
          this.getMpJob()
        }
      })
    }
  }

  ngOnChanges(changes: SimpleChanges): void {

    console.log("cahnegs of client job", changes.jobFromClient);
    if (changes.jobFromClient && changes.jobFromClient.currentValue) {
      // this.job = changes.jobFromClient.currentValue
      this.jobId = changes.jobFromClient.currentValue._id
      this.getMpJob()
      this.clientData = this.jobId
      this.hideTitle = true;
    }

  }

  // UTILITY FUNCTIONS

  newLernerAdd(event) {
    console.log("event when new learner adaded", event);
    this.addLearner = event
  }
  jobEdit(event) {
    console.log("event of when job edit", event);
    this.trackerDetails = event.tracker
  }
  singleJobData(event) {
    console.log("event of single job details", event);
    let name
    if (event.tracker == null) {
      console.log("call this ", event.tracker);
      name = []
    } else {
      console.log("check this else part", event.tracker);
      name = event.tracker
    }
    console.log("what is name data=============", name);

    if (event && event.tracker == null) {
      console.log("call this first if");
      event.tracker = []
      this.singleJobDetails = event.tracker
    } else {
      this.singleJobDetails = event.tracker
    }
    // if (event) {
    this.cdr.detectChanges();
    // }
  }


  changeParams(event) {

    console.log("Tab changed =====>>>>> ", event)
    // go to go back in tabs
    // replaceState to go back to job.
    //  {
    {
      this.location.replaceState(
        this.router.createUrlTree(
          [this.locationStrategy.path().split('?')[0]], // Get uri
          { relativeTo: this.activatedRoute, queryParams: { currentTab: event.index }, queryParamsHandling: 'merge' }).toString()
      );
    }
    // }
  }

  // APIS
  getMpJob() {
    console.log("GETTING JOBS");
    this._mpjobService.getJobById(this.jobId).subscribe(res => {
      console.log("res in mpJobs page", res)
      this.job = res[0]
      // if (this.job && (this.job.tracker && this.job.tracker.length)) {
      this.trackerDetails = this.job ? this.job.tracker : []
      // }
    })
  }

}
